import { render, staticRenderFns } from "./BillableAccRuleAdd.vue?vue&type=template&id=27cb4736&scoped=true"
import script from "./BillableAccRuleAdd.vue?vue&type=script&lang=js"
export * from "./BillableAccRuleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cb4736",
  null
  
)

export default component.exports